import { Constant } from '@genial/config';
import { Utils } from '@genial/utils';
import { atom } from 'recoil';

import { permissionsFromApiQuery, permissionsFromFirebaseQuery } from './queries';
import { PermissionAccess, PermissionGroup, UserPermissions } from './types';

export const fetchPermissions = async (): Promise<UserPermissions> => {
  const jwtToken = await Utils.Storage.GetItem(Constant.TokenKey);
  const userProfileData = await Utils.Storage.GetItem(Constant.UserProfileKey);

  if (!jwtToken || !userProfileData) {
    return {
      permissionAccess: {},
    } as UserPermissions;
  }

  const userProfile = JSON.parse(userProfileData);
  const firebasePermissions = await permissionsFromFirebaseQuery();
  const apiPermissions = await permissionsFromApiQuery(jwtToken);

  const user: number[] = apiPermissions.grupos.map((userNumber) => userNumber.idGrupo);

  const basePermissions: PermissionGroup = {
    compliance: firebasePermissions.compliance.assessores,
    consolidatedPortfolio: firebasePermissions.consolidatedPortfolio.freeToUse,
    partners: firebasePermissions.partners.telas.geradorOrdens,
    functionalities: firebasePermissions.partners.funcionalidades,
    unicredBrb: firebasePermissions.unicred.telas.geradorOrdens,
    user,
    idFilialParceiroIntranet: userProfile?.idFilialParceiroIntranet,
    trading: firebasePermissions.trading,
  };

  const compilePermissionAccess = (permissionGroup: PermissionGroup) => {
    const complianceAccess: boolean = permissionGroup.compliance?.includes(
      permissionGroup.idFilialParceiroIntranet!
    )!;

    const brbUnicredPermission = permissionGroup.unicredBrb;

    const isBrbOrUnicred =
      brbUnicredPermission?.includes(permissionGroup.idFilialParceiroIntranet!) ?? false;

    const firebasePermissionsFromGroup = permissionGroup.partners;

    const userPermissionsFromGroup = permissionGroup.user;

    const permissoesGerador: boolean =
      firebasePermissionsFromGroup?.some(
        (permission: number) => userPermissionsFromGroup?.includes(permission) ?? false
      ) ?? false;

    const tradingPermissionsFromGroup = permissionGroup.trading;

    const permissoesTrading: boolean =
      tradingPermissionsFromGroup?.some(
        (permission: number) => userPermissionsFromGroup?.includes(permission) ?? false
      ) ?? false;

    const permissionAccess: PermissionAccess = {
      consolidated: permissionGroup.consolidatedPortfolio,
      compliance: complianceAccess,
      screen: isBrbOrUnicred ? !isBrbOrUnicred : permissoesGerador,
      trading: permissoesTrading,
    };

    return permissionAccess;
  };

  return {
    ...basePermissions,
    permissionAccess: compilePermissionAccess(basePermissions),
  };
};

export const userPermissions = atom<UserPermissions>({
  key: 'Permission/User',
  default: {
    permissionAccess: {},
  },
});
